// Mirrors the API validator (UpdateApplicantRequestValidator): the address must not contain @ (blocks email addresses)
export const ADDRESS_INVALID_MESSAGE = 'Ogiltig adress. Adressen får inte innehålla @.';

export const isValidAddress = (value) => !value || !value.includes('@');

// vee-validate rule: returns true when valid, otherwise the error message
export const validateAddress = (value) => (isValidAddress(value) ? true : ADDRESS_INVALID_MESSAGE);
